export default __webpack_public_path__ + "cover.32e5400d8e809ccfe408c126f274baae.jpg"